export default "__VITE_ASSET__EeJ50g3q__"